var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 562,
    height: 507,
    viewBox: "0 0 562 507",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Illustration"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shape"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval",
    opacity: 0.1,
    filter: "url(#filter0_f)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 107.745,
    cy: 244.5,
    rx: 101.745,
    ry: 102.5,
    fill: "#2C4190"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Oval_2",
    opacity: 0.05,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M336.032 157.826C336.032 104.326 379.404 60.9563 432.906 60.9563C486.408 60.9563 529.78 104.326 529.78 157.826C529.78 211.326 486.408 254.696 432.906 254.696C379.404 254.696 336.032 211.326 336.032 157.826ZM488.389 157.386C488.389 126.988 463.745 102.346 433.347 102.346C402.948 102.346 378.304 126.988 378.304 157.386C378.304 187.784 402.948 212.426 433.347 212.426C463.745 212.426 488.389 187.784 488.389 157.386Z",
    fill: "#4BB3FD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_3",
    opacity: 0.1,
    cx: 275.822,
    cy: 48.5,
    rx: 33.4161,
    ry: 33.5,
    stroke: "#2C4190",
    strokeWidth: 30
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    opacity: 0.1,
    d: "M433.272 60.9563C486.572 60.9563 529.78 104.326 529.78 157.826C529.78 211.326 486.572 254.696 433.272 254.696C401.162 254.696 371.688 238.816 353.798 212.796C347.287 203.326 349.657 190.352 359.091 183.817C368.431 177.348 381.193 179.615 387.764 188.849L387.961 189.131C398.182 203.997 414.951 213.032 433.272 213.032C463.647 213.032 488.271 188.315 488.271 157.826C488.271 127.642 464.137 103.116 434.181 102.628L433.272 102.621C421.809 102.621 412.517 93.2939 412.517 81.7886C412.517 70.2832 421.809 60.9563 433.272 60.9563Z",
    fill: "#4BB3FD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mobile Banking App"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Phone3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M149.71 162.137C149.71 148.254 160.964 137 174.847 137H301.957C315.84 137 327.094 148.254 327.094 162.137V479.625C327.094 493.508 315.84 504.762 301.957 504.762H174.847C160.964 504.762 149.71 493.508 149.71 479.625V162.137Z",
    fill: "#8EE9F4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 48"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.107 162.933C156.107 152.703 164.4 144.411 174.629 144.411H195.926C196.585 144.411 197.124 144.935 197.144 145.594V145.594C197.28 150.315 201.147 154.072 205.87 154.072H270.352C275.075 154.072 278.942 150.315 279.079 145.594V145.594C279.098 144.935 279.637 144.411 280.297 144.411H301.593C311.822 144.411 320.115 152.703 320.115 162.933V476.634C320.115 486.863 311.822 495.156 301.593 495.156H174.629C164.4 495.156 156.107 486.863 156.107 476.634V162.933Z",
    fill: "#262E43"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 144,
    width: 165,
    height: 352
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M156.107 162.933C156.107 152.703 164.4 144.411 174.629 144.411H195.926C196.585 144.411 197.124 144.935 197.144 145.594V145.594C197.28 150.315 201.147 154.072 205.87 154.072H270.352C275.075 154.072 278.942 150.315 279.079 145.594V145.594C279.098 144.935 279.637 144.411 280.297 144.411H301.593C311.822 144.411 320.115 152.703 320.115 162.933V476.634C320.115 486.863 311.822 495.156 301.593 495.156H174.629C164.4 495.156 156.107 486.863 156.107 476.634V162.933Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_4",
    cx: 218.287,
    cy: 357.888,
    rx: 14.0671,
    ry: 14.0525,
    fill: "#E97EFF",
    fillOpacity: 0.548951
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.086 209.239C176.086 206.692 178.15 204.628 180.697 204.628H296.76C299.307 204.628 301.371 206.692 301.371 209.239V209.239C301.371 211.785 299.307 213.85 296.76 213.85H180.697C178.15 213.85 176.086 211.785 176.086 209.239V209.239Z",
    fill: "#E97EFF",
    fillOpacity: 0.548951
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    d: "M248.017 143.438C249.534 143.438 250.764 144.618 250.764 146.073C250.764 147.496 249.588 148.656 248.118 148.706L248.017 148.708H216.95C215.432 148.708 214.202 147.529 214.202 146.073C214.202 144.65 215.378 143.491 216.849 143.44L216.95 143.438H248.017Z",
    fill: "#4BB3FD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    d: "M259.151 142.999C260.669 142.999 261.899 144.228 261.899 145.744C261.899 147.226 260.723 148.434 259.252 148.487L259.151 148.489H259.007C257.49 148.489 256.26 147.26 256.26 145.744C256.26 144.262 257.436 143.054 258.907 143.001L259.007 142.999H259.151Z",
    fill: "#4BB3FD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "BoardPieChart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_5",
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.672 319.757C166.672 314.921 170.592 311 175.429 311H341.763C346.6 311 350.52 314.921 350.52 319.757V422.729C350.52 427.565 346.6 431.486 341.763 431.486H175.429C170.592 431.486 166.672 427.565 166.672 422.729V319.757Z",
    fill: "#313A53"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 166,
    y: 311,
    width: 185,
    height: 121
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.672 319.757C166.672 314.921 170.592 311 175.429 311H341.763C346.6 311 350.52 314.921 350.52 319.757V422.729C350.52 427.565 346.6 431.486 341.763 431.486H175.429C170.592 431.486 166.672 427.565 166.672 422.729V319.757Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M162.547 306.275H355.234V341.712H162.547L162.547 306.275Z",
    fill: "#A8EDF6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_8",
    opacity: 0.365606,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M181.992 332.262C181.992 331.284 182.785 330.49 183.764 330.49H242.682C243.66 330.49 244.453 331.284 244.453 332.262V332.262C244.453 333.241 243.66 334.034 242.682 334.034H183.764C182.785 334.034 181.992 333.241 181.992 332.262V332.262Z",
    fill: "#6FA3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_9",
    x: 181.992,
    y: 320.45,
    width: 32.9984,
    height: 3.5437,
    rx: 1.77185,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    x: 187.885,
    y: 400.774,
    width: 32.9984,
    height: 4.13432,
    rx: 2.06716,
    fill: "#D64323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.885 414.653C187.885 413.512 188.81 412.586 189.952 412.586H207.031C208.173 412.586 209.098 413.512 209.098 414.653V414.653C209.098 415.795 208.173 416.72 207.031 416.72H189.952C188.81 416.72 187.885 415.795 187.885 414.653V414.653Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12",
    x: 240.329,
    y: 400.774,
    width: 32.9984,
    height: 4.13432,
    rx: 2.06716,
    fill: "#FF9F43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M240.329 414.653C240.329 413.512 241.255 412.586 242.396 412.586H259.475C260.617 412.586 261.542 413.512 261.542 414.653V414.653C261.542 415.795 260.617 416.72 259.475 416.72H242.396C241.255 416.72 240.329 415.795 240.329 414.653V414.653Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14",
    x: 294.541,
    y: 400.774,
    width: 32.9984,
    height: 4.13432,
    rx: 2.06716,
    fill: "#2C9048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M294.541 414.653C294.541 413.512 295.467 412.586 296.608 412.586H313.687C314.829 412.586 315.754 413.512 315.754 414.653V414.653C315.754 415.795 314.829 416.72 313.687 416.72H296.608C295.467 416.72 294.541 415.795 294.541 414.653V414.653Z",
    fill: "#F8F9FA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.04 388.814C320.396 388.814 327.981 381.211 327.981 371.834C327.981 362.456 320.396 354.853 311.04 354.853C301.683 354.853 294.099 362.456 294.099 371.834C294.099 381.211 301.683 388.814 311.04 388.814ZM311.04 382.022C305.426 382.022 300.875 377.46 300.875 371.834C300.875 366.207 305.426 361.645 311.04 361.645C316.654 361.645 321.204 366.207 321.204 371.834C321.204 377.46 316.654 382.022 311.04 382.022Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M327.981 371.834C327.981 362.456 320.396 354.853 311.04 354.853C309.168 354.853 307.651 356.374 307.651 358.249C307.651 360.125 309.168 361.645 311.04 361.645C316.59 361.645 321.101 366.104 321.203 371.642L321.204 371.834C321.204 373.709 322.721 375.23 324.593 375.23C326.464 375.23 327.981 373.709 327.981 371.834Z",
    fill: "#2C9048"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M258.007 388.814C267.363 388.814 274.948 381.211 274.948 371.834C274.948 362.456 267.363 354.853 258.007 354.853C248.65 354.853 241.065 362.456 241.065 371.834C241.065 381.211 248.65 388.814 258.007 388.814ZM258.007 382.022C252.393 382.022 247.842 377.46 247.842 371.834C247.842 366.207 252.393 361.645 258.007 361.645C263.62 361.645 268.171 366.207 268.171 371.834C268.171 377.46 263.62 382.022 258.007 382.022Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    d: "M258.006 388.814C267.363 388.814 274.948 381.211 274.948 371.834C274.948 362.456 267.363 354.853 258.006 354.853C256.135 354.853 254.618 356.374 254.618 358.249C254.618 360.125 256.135 361.645 258.006 361.645C263.62 361.645 268.171 366.207 268.171 371.834C268.171 377.396 263.723 381.918 258.197 382.02L258.006 382.022C256.135 382.022 254.618 383.542 254.618 385.418C254.618 387.293 256.135 388.814 258.006 388.814Z",
    fill: "#FF9F43"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Oval_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M204.973 388.814C214.33 388.814 221.915 381.211 221.915 371.834C221.915 362.456 214.33 354.853 204.973 354.853C195.617 354.853 188.032 362.456 188.032 371.834C188.032 381.211 195.617 388.814 204.973 388.814ZM204.973 382.022C199.36 382.022 194.809 377.46 194.809 371.834C194.809 366.207 199.36 361.645 204.973 361.645C210.587 361.645 215.138 366.207 215.138 371.834C215.138 377.46 210.587 382.022 204.973 382.022Z",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.032 371.834C188.032 381.211 195.617 388.814 204.973 388.814C214.33 388.814 221.915 381.211 221.915 371.834C221.915 362.456 214.33 354.853 204.973 354.853C203.102 354.853 201.585 356.374 201.585 358.249C201.585 360.125 203.102 361.645 204.973 361.645C210.587 361.645 215.138 366.207 215.138 371.834C215.138 377.46 210.587 382.022 204.973 382.022C199.36 382.022 194.809 377.46 194.809 371.834C194.809 369.958 193.292 368.437 191.42 368.437C189.549 368.437 188.032 369.958 188.032 371.834Z",
    fill: "#D64323"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "VisaCard2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_16",
    filter: "url(#filter2_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.62 184H351.014C353.192 184 354.958 185.771 354.958 187.955V291.769C354.958 293.953 353.192 295.723 351.014 295.723H168.62C166.442 295.723 164.677 293.953 164.677 291.769V187.955C164.677 185.771 166.442 184 168.62 184Z",
    fill: "#BFB9FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 46"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 45"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 43"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval_8",
    cx: 303.887,
    cy: 213.077,
    rx: 11.4366,
    ry: 11.395,
    fill: "#8E83FF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval Copy 10",
    cx: 319.661,
    cy: 213.077,
    rx: 11.4366,
    ry: 11.395,
    fill: "#FFBB7A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M311.67 204.925L311.775 204.827C313.961 206.902 315.323 209.831 315.323 213.077C315.323 216.323 313.961 219.252 311.775 221.327C309.587 219.253 308.225 216.323 308.225 213.077C308.225 209.882 309.544 206.994 311.67 204.925L311.775 204.827L311.67 204.925Z",
    fill: "white",
    fillOpacity: 0.416193
  })), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M192.873 220.346H216.732C217.604 220.346 218.31 221.05 218.31 221.918V239.207C218.31 240.075 217.604 240.779 216.732 240.779H192.873C192.002 240.779 191.296 240.075 191.296 239.207V221.918C191.296 221.05 192.002 220.346 192.873 220.346Z",
    fill: "#9F95FF"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 44"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.845 252.37H214.563C216.524 252.37 218.113 253.953 218.113 255.906C218.113 257.859 216.524 259.443 214.563 259.443H194.845C192.885 259.443 191.296 257.859 191.296 255.906C191.296 253.953 192.885 252.37 194.845 252.37Z",
    fill: "white",
    fillOpacity: 0.646908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.845 270.052H244.141C246.101 270.052 247.69 271.635 247.69 273.588C247.69 275.541 246.101 277.125 244.141 277.125H194.845C192.885 277.125 191.296 275.541 191.296 273.588C191.296 271.635 192.885 270.052 194.845 270.052Z",
    fill: "white",
    fillOpacity: 0.646908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M307.239 270.052H326.957C328.917 270.052 330.506 271.635 330.506 273.588C330.506 275.541 328.917 277.125 326.957 277.125H307.239C305.279 277.125 303.689 275.541 303.689 273.588C303.689 271.635 305.279 270.052 307.239 270.052Z",
    fill: "white",
    fillOpacity: 0.646908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.845 201.289H214.563C216.524 201.289 218.113 202.872 218.113 204.825C218.113 206.778 216.524 208.362 214.563 208.362H194.845C192.885 208.362 191.296 206.778 191.296 204.825C191.296 202.872 192.885 201.289 194.845 201.289Z",
    fill: "white",
    fillOpacity: 0.646908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M231.915 252.37H251.634C253.594 252.37 255.183 253.953 255.183 255.906C255.183 257.859 253.594 259.443 251.634 259.443H231.915C229.955 259.443 228.366 257.859 228.366 255.906C228.366 253.953 229.955 252.37 231.915 252.37Z",
    fill: "white",
    fillOpacity: 0.646908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.775 252.37H289.493C291.453 252.37 293.042 253.953 293.042 255.906C293.042 257.859 291.453 259.443 289.493 259.443H269.775C267.815 259.443 266.226 257.859 266.226 255.906C266.226 253.953 267.815 252.37 269.775 252.37Z",
    fill: "white",
    fillOpacity: 0.646908
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle Copy 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M306.845 252.37H326.563C328.524 252.37 330.113 253.953 330.113 255.906C330.113 257.859 328.524 259.443 326.563 259.443H306.845C304.885 259.443 303.296 257.859 303.296 255.906C303.296 253.953 304.885 252.37 306.845 252.37Z",
    fill: "white",
    fillOpacity: 0.646908
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Men1.1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "LLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.372 479.69C126.372 479.69 126.236 488.374 131.569 491.458C136.901 494.543 145.162 500.274 145.162 500.274L113.735 501.339L114.631 479.612L126.372 479.69Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.405 490.205C115.835 490.456 115.304 493.971 119.713 493.8C122.926 493.675 127.937 487.749 132.059 489.944C138.35 493.294 145.727 497.812 147.536 498.887C149.345 499.963 150.06 504.021 144.715 504.519C139.603 504.995 132.704 504.942 130.976 504.627C129.247 504.312 126.041 502.107 123.461 502.459C120.882 502.812 120.588 503.702 119.147 504.095C117.705 504.489 113.354 504.575 112.903 503.36C112.385 501.966 111.866 490.047 113.405 490.205Z",
    fill: "#482B61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110.969 295.474C110.969 295.474 122.957 389.573 123.959 398.472C124.961 407.371 130.465 470.679 129.712 479.123C128.944 487.723 112.857 487.769 110.699 481.281C107.745 472.4 100.916 428.014 99.7872 418.746C98.6578 409.477 99.0544 398.716 94.5156 389.225C91.2658 382.43 80.5127 297.886 80.5127 297.886L110.969 295.474Z",
    fill: "#2F2B57"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    opacity: 0.59096,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M103.922 404.214L103.965 404.637C104.422 409.552 104.806 425.834 105.116 453.481L104.426 449.352C102.262 436.258 100.34 423.287 99.7869 418.746C98.6811 409.67 99.0383 399.163 94.7926 389.82L94.5153 389.225C93.0851 386.234 90.2015 368.185 87.4209 348.911L88.294 351.248C97.5779 376.216 102.787 393.871 103.922 404.214Z",
    fill: "white",
    fillOpacity: 0.192499
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 10",
    d: "M134.382 491.454L132.879 493.704",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 10_2",
    d: "M137.007 492.334L135.504 494.584",
    stroke: "white",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M53.3487 481.682L50.5361 500.672L64.1299 500.604L63.6849 481.329L53.3487 481.682Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.0317 503.745C47.9863 502.637 49.0178 495.451 50.5363 492.605C51.6378 490.542 54.0803 490.058 57.6543 490.044C62.2643 490.026 66.117 490.723 66.1117 492.605C66.0955 498.366 67.5562 502.796 67.6543 503.302C67.9426 504.787 63.8195 505.896 58.1879 505.839C53.5784 505.794 48.1023 505.473 48.0317 503.745Z",
    fill: "#482B61"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5597 298.563C95.5597 298.563 89.3269 340.561 85.5543 367.134C81.8469 393.245 70.8675 471.132 69.733 479.285C68.6914 486.77 49.68 486.77 49.8801 477.705C50.0802 468.64 48.3201 412.152 51.86 403.789C55.3999 395.425 52.3182 385.692 52.4468 377.567C52.576 369.442 57.6669 299.106 57.6669 299.106L95.5597 298.563Z",
    fill: "#3A3669"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    opacity: 0.461565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.4621 353.024L61.1645 354.105C57.5555 367.072 56.31 368.241 57.3328 388.923L57.3433 389.344C57.3789 394.547 54.9043 421.474 49.9195 470.126L49.8969 467.101C49.7221 447.254 48.991 411.369 51.7698 404.014L51.8597 403.789C55.3996 395.425 52.3178 385.692 52.4464 377.567C52.5756 369.442 57.6666 299.106 57.6666 299.106L64.1696 299.012L64.2361 302.234C64.7039 327.396 63.7793 344.326 61.4621 353.024V353.024Z",
    fill: "white",
    fillOpacity: 0.192499
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 9",
    d: "M56.0068 494.256H60.9829",
    stroke: "white",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 9_2",
    d: "M56.0068 496.894H60.9829",
    stroke: "white",
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Head"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2422 213.711C72.2422 213.711 77.4493 212.483 77.63 203.907C77.8106 195.331 77.6838 192.404 77.6838 192.404L90.0286 192.196C90.0286 192.196 90.1536 201.754 90.1554 205.21C90.1602 214.495 96.597 213.711 96.597 213.711C96.597 213.711 95.2589 221.24 84.8659 221.827C76.7513 222.287 72.2422 213.711 72.2422 213.711Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5516 188.069C71.4349 187.87 72.2695 195.399 77.5848 195.389C77.5848 195.389 83.2971 206.933 92.2652 206.963C96.5851 206.977 97.9956 203.11 99.2906 200.395C100.586 197.68 101.536 193.619 101.615 191.132C101.7 188.481 101.711 179.77 101.711 179.77L76.3524 179.759L76.5516 188.069Z",
    fill: "url(#paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    d: "M91.9057 201.462C92.6726 201.885 93.5853 201.781 94.2918 201.462",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8",
    d: "M77.3489 192.367C77.4015 191.159 77.035 190.2 75.8096 190.008",
    stroke: "#DE6767",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.5512 188.069C76.5512 188.069 78.9038 190.799 79.7741 190.874C80.645 190.949 79.6527 183.487 80.9345 182.128C83.75 179.14 91.1072 184.216 98.844 182.976C101.71 182.517 101.659 187.415 101.659 187.415C108.892 180.786 111.514 175.557 102.871 173.373C102.802 167.763 99.5911 166.355 93.3822 168.957C92.5523 161.378 81.8243 162.522 76.9411 172.164C73.4066 168.707 68.4385 171.498 70.5469 176.699C66.7408 176.699 68.7242 186.925 73.2095 190.439C73.7447 188.904 74.7227 188.069 76.5512 188.069Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    d: "M90.1709 199.031C90.1709 199.031 92.6072 201.335 95.6658 199.459",
    stroke: "#DE6767",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "LArm"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.671 241.247C161.671 241.247 163.135 233.107 165.072 230.255C167.01 227.403 167.574 222.61 169.402 222.786C171.23 222.963 169.399 230.614 169.399 230.614C169.399 230.614 177.923 224.219 181.79 222.015C185.319 220.006 183.383 230.404 182.831 231.729C181.518 234.885 166.322 246.793 166.322 246.793C166.322 246.793 162.003 241.971 161.671 241.247Z",
    fill: "url(#paint4_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M169.4 230.614C169.4 230.614 168.77 233.231 169.084 233.231C169.399 233.231 175.184 226.405 175.184 226.405L169.4 230.614Z",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.464 223.029C116.632 232.068 132.22 255.423 132.22 255.423C132.22 255.423 157.765 238.768 161.016 238.734C164.266 238.699 168.68 243.012 168.402 245.989C168.125 248.966 140.156 275.074 131.186 274.854C117.238 274.512 99.7474 238.241 97.9514 233.393C93.141 220.407 108.398 214.213 112.464 223.029Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M132.128 255.406C132.128 255.406 135.078 259.727 135.606 259.444C136.135 259.16 134.447 254.161 134.447 254.161L132.128 255.406Z",
    fill: "black",
    fillOpacity: 0.159856
  })), /*#__PURE__*/React.createElement("g", {
    id: "Body"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7681 224.475C49.4593 230.751 58.4221 262.381 55.9562 277.178C54.0059 288.882 52.1441 304.996 57.1989 308.573C62.3452 312.216 106.644 315.108 112.959 304.996C117.968 296.973 113.867 279.182 112.959 271.066C111.147 254.875 113.883 226.894 110.809 221.171C108.902 217.621 95.9018 213.043 95.4134 213.185C94.9251 213.327 93.7772 218.357 85.5568 218.357C77.3365 218.357 73.7065 213.185 73.2648 213.043C72.8231 212.901 51.9524 218.798 50.7681 224.475Z",
    fill: "#D64323"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.2441 213.041L73.2648 213.043C73.7065 213.185 77.3365 218.357 85.5568 218.357C93.7772 218.357 94.9251 213.327 95.4134 213.185C95.5897 213.134 97.3959 213.697 99.7221 214.606L99.7115 214.713C93.836 224.579 77.6775 225.795 69.0403 214.507L68.8447 214.246L69.8085 213.947C71.5727 213.411 72.835 213.088 73.1783 213.045L73.2441 213.041Z",
    fill: "#FF9B86"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.7959 228.834L51.5202 228.935C59.2037 230.034 63.71 231.773 65.0392 234.152C65.9112 235.712 65.5057 240.991 63.8227 249.988L63.644 250.932C62.0831 259.088 63.8679 267.524 68.5803 274.33L68.8451 274.707C70.4387 276.936 71.9079 279.872 73.2525 283.514C76.3716 291.962 69.737 299.081 73.939 311.649L73.0811 311.586C65.2704 310.988 58.9534 309.815 57.1989 308.573C52.1441 304.996 54.0059 288.882 55.9563 277.179C58.0544 264.588 51.8783 239.811 50.7959 228.834Z",
    fill: "black",
    fillOpacity: 0.0667614
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rarm"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.7739 291.701C59.7739 291.701 62.723 295.18 65.2401 295.613C67.7572 296.046 78.2911 298.106 78.934 298.411C79.5417 298.7 81.6199 299.794 83.397 301.549C84.9367 303.07 87.6003 306.677 86.7072 307.297C85.7525 307.961 83.1751 304.708 81.8819 303.904C80.5258 303.061 78.4418 302.314 78.4418 302.314C78.4418 302.314 83.5968 308.533 83.269 309.619C83.0297 310.412 78.6463 311.767 77.709 311.665C76.7717 311.563 71.6067 307.782 69.2852 307.341C67.675 307.037 60.466 305.084 58.9455 303.618C57.4255 302.151 54.0059 299.174 54.0059 299.174L59.7739 291.701Z",
    fill: "url(#paint5_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.275 310.34C82.275 310.34 76.8805 304.905 76.6553 304.997C76.4302 305.09 81.3559 310.719 81.3559 310.719L82.275 310.34Z",
    fill: "#F28585"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.8706 311.233C79.8706 311.233 75.8295 307.53 75.5654 307.709C75.3013 307.887 78.8021 311.535 78.8021 311.535L79.8706 311.233Z",
    fill: "#F28585"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.7061 219.232C71.0356 225.093 65.4708 235.748 58.5603 245.521C52.1049 254.65 42.3209 268.401 42.3209 268.401C42.3209 268.401 60.7184 288.554 62.4956 292.282C64.2727 296.011 59.7345 303.014 54.0926 301.101C48.4502 299.189 16.3425 275.404 22.8717 264.164C32.8446 246.995 52.8676 212.309 62.7061 219.232Z",
    fill: "#FF5C5D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.321 268.401C42.321 268.401 38.5456 264.407 38.8983 263.945C39.251 263.482 43.506 266.747 43.506 266.747L42.321 268.401Z",
    fill: "black",
    fillOpacity: 0.159856
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M345.257 439.204C345.257 425.888 356.052 415.093 369.368 415.093L437.966 415.093V487.26C437.966 489.469 436.175 491.26 433.966 491.26H349.257C347.048 491.26 345.257 489.469 345.257 487.26L345.257 439.204Z",
    fill: "#86E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.633 476.224L421.269 476.224V491.26H353.633L353.633 476.224Z",
    fill: "#86E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.769 490.715L444.035 501.401H423.41L426.984 490.715H439.769Z",
    fill: "#86E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369.497 490.715L373.764 501.401H353.139L356.713 490.715H369.497Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M509.161 490.715L513.428 501.401H492.803L496.377 490.715H509.161Z",
    fill: "#86E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M397.97 360.481C397.97 347.368 408.449 336.659 421.558 336.375L438.492 336.008V422.277H397.97L397.97 360.481Z",
    fill: "#91D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.875 360.119C405.875 346.803 416.67 336.008 429.986 336.008H491.667C503.729 336.008 513.507 345.786 513.507 357.848V422.288C513.507 423.253 512.725 424.035 511.76 424.035H405.875L405.875 360.119Z",
    fill: "#C6F9FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M483.427 351.792C483.427 343.074 490.493 336.008 499.21 336.008V336.008C507.106 336.008 513.507 342.409 513.507 350.305V413.499C513.507 414.464 512.725 415.246 511.76 415.246H483.427V351.792Z",
    fill: "#86E5F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M353.633 435.799C353.633 428.84 359.274 423.199 366.233 423.199H433.69V481.124H353.633V435.799Z",
    fill: "#C6F9FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Wom1.4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.719 328.514C447.465 326.01 448.172 311.252 440.003 306.133C448.428 288.461 428.945 270.915 415.599 281.736C406.85 277.989 399.579 292.611 407.72 303.968C404.307 323.468 411.254 328.509 423.777 328.723L436.719 328.514Z",
    fill: "#422851"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M436.585 324.989C436.585 324.989 431.358 323.762 431.176 315.192C430.995 306.622 431.122 303.696 431.122 303.696L419.608 303.488C419.608 303.488 419.483 313.039 419.481 316.494C419.476 325.773 413.015 324.989 413.015 324.989C413.015 324.989 414.358 332.513 424.791 333.1C432.937 333.559 436.585 324.989 436.585 324.989Z",
    fill: "url(#paint6_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M433.807 299.417C438.944 299.218 438.106 306.741 432.77 306.731C432.77 306.731 429.671 317.419 418.912 317.419C410.173 317.419 409.605 304.962 409.526 302.477C409.44 299.828 409.43 291.123 409.43 291.123L434.007 291.112L433.807 299.417Z",
    fill: "url(#paint7_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    d: "M420.985 310.239C420.985 310.239 418.423 312.41 415.454 310.377",
    stroke: "#F77B7B",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    d: "M419.294 312.753C418.497 313.121 417.729 313.148 417.044 312.781",
    stroke: "#F49494",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 8_2",
    d: "M433.284 303.463C433.231 302.256 433.599 301.297 434.829 301.105",
    stroke: "#F77B7B",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M434.62 298.487C434.62 298.487 431.805 302.267 431.234 302.287C430.664 302.307 430.464 297.371 430.464 297.371C427.011 297.107 418.271 295.366 416.128 291.309C414.63 294.888 411.766 296.478 409.884 296.173L409.527 303.778L408.649 288.489H435.309L434.62 298.487Z",
    fill: "#422851"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LLeg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.979 476.119C383.979 476.119 388.587 485.431 384.809 488.365C381.026 491.3 371.033 496.801 371.033 496.801L397.508 495.136L391.623 474.826L383.979 476.119Z",
    fill: "url(#paint8_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.947 484.981C393.64 485.134 395.035 489.535 392.207 489.87C389.383 490.204 388.011 486.034 384.808 487.356C381.604 488.678 369.92 495.513 369.46 498.307C368.994 501.1 373.347 501.922 379.317 501.291C385.287 500.66 386.387 498.535 390.869 499.391C395.345 500.247 398.699 498.883 398.551 495.61C398.403 492.338 396.253 484.828 394.947 484.981Z",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.346 488.034L383.856 488.799C384.18 489.285 384.021 489.943 383.511 490.227L375.781 494.543C375.491 494.706 375.138 494.713 374.841 494.562L373.672 493.968C375.597 492.573 377.172 491.524 378.912 490.495C380.248 489.704 381.727 488.889 383.346 488.034Z",
    fill: "white",
    fillOpacity: 0.540975
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M423.859 394.043C415.844 394.402 371.235 404.274 363.13 405.951C355.026 407.628 348.174 416.704 354.354 427.213C361.295 439.01 379.205 472.514 383.554 480.066C385.706 483.805 396.564 481.709 394.014 475.434C389.259 463.738 387.051 434.356 374.929 423.643C374.929 423.643 415.695 430.742 433.304 422.61C446.102 416.699 443.207 393.178 423.859 394.043Z",
    fill: "url(#paint9_linear)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "LArm_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.069 346.62C367.069 346.62 367.159 340.095 364.878 336.684C362.597 333.274 362.506 329.652 360.78 329.77C359.053 329.889 360.763 338.309 360.763 338.309C360.763 338.309 358.572 337.471 356.999 336.412C355.425 335.353 350.653 330.131 349.538 331.057C347.647 332.633 350.693 341.527 352.351 343.305C354.015 345.083 363.106 350.932 363.106 350.932L367.069 346.62Z",
    fill: "url(#paint10_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M416.324 342.71C412.596 351.363 405.769 367.258 402.955 372C399.428 377.939 393.866 380.556 387.354 376.149C380.512 371.519 361.671 353.46 361.119 349.369C360.572 345.279 365.183 340.37 369.355 342.912C373.528 345.453 390.866 359.89 390.866 359.89C390.866 359.89 397.863 341.943 403.492 331.546C408.366 322.551 421.999 329.556 416.324 342.71Z",
    fill: "#6A5EE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.793 359.899C390.793 359.899 388.914 366.277 388.474 365.908C388.035 365.538 388.81 358.232 388.81 358.232L390.793 359.899Z",
    fill: "black",
    fillOpacity: 0.302803
  })), /*#__PURE__*/React.createElement("g", {
    id: "PhoneMini4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_28",
    d: "M343.366 330.492C342.956 329.231 343.646 327.877 344.907 327.468L354.376 324.391C355.637 323.981 356.991 324.671 357.4 325.932L365.043 349.452C365.452 350.713 364.762 352.067 363.502 352.477L354.032 355.553C352.772 355.963 351.418 355.273 351.008 354.013L343.366 330.492Z",
    fill: "#7596FF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_29",
    x: 343.561,
    y: 327.497,
    width: 14.757,
    height: 29.5312,
    rx: 2.4,
    transform: "rotate(-18 343.561 327.497)",
    fill: "#93C2F9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_30",
    d: "M346.395 327.685L347.46 327.339C347.677 327.268 347.908 327.366 348.012 327.56L348.045 327.637C348.124 327.881 348.387 328.015 348.63 327.936L353.763 326.268C353.98 326.198 354.109 325.983 354.08 325.764L354.061 325.683C353.982 325.438 354.115 325.176 354.359 325.097L355.418 324.753C356.205 324.497 357.047 324.894 357.36 325.645L357.406 325.767V325.767L364.806 348.613C365.128 349.611 364.582 350.681 363.587 351.006L355.166 353.742C354.213 354.053 353.193 353.567 352.822 352.652L352.776 352.524C352.775 352.524 352.775 352.523 352.777 352.522L345.378 329.681C345.108 328.849 345.563 327.955 346.395 327.685Z",
    fill: "#E6F3FF"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Body_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M453.585 332.284C453.585 332.284 444.6 362.387 444.334 368.085C444.068 373.784 451.683 390.533 450.386 394.766C447.397 404.548 409.233 408.761 407.775 395.601C407.095 389.463 408.51 383.955 406.879 376.723C405.254 369.492 398.723 358.745 402.428 348.642C406.132 338.538 405.139 329.191 407.789 327.424C410.439 325.657 416.632 323.781 416.632 323.781C419.644 328.216 429.812 328.151 434.664 323.468C434.664 323.468 446.718 325.808 453.585 332.284Z",
    fill: "#2C4190"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M445.534 337.16C439.545 346.67 439.563 363.228 436.346 365.396C433.13 367.565 420.61 365.437 420.61 367.154C420.61 368.871 437.911 384.61 435.071 392.133C433.584 396.073 433.987 399.597 436.281 402.707L437.03 402.543C443.847 401.002 449.327 398.234 450.386 394.766C451.683 390.533 443.19 373.784 443.456 368.085C443.682 363.248 450.823 340.826 452.977 334.159C451.223 331.064 448.743 332.064 445.534 337.16Z",
    fill: "black",
    fillOpacity: 0.199355
  })), /*#__PURE__*/React.createElement("g", {
    id: "RArm"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M435.32 362.39C435.32 362.39 427.752 355.688 425.436 354.911C423.119 354.133 409.551 353.199 409.637 354.956C409.734 356.839 417.021 356.73 417.776 357.657C418.531 358.583 418.703 364.914 421.557 365.624C424.406 366.335 432.946 367.561 432.946 367.561L435.32 362.39Z",
    fill: "url(#paint11_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.454 334.014C463.427 345.273 470.234 362.424 472.847 369.111C475.46 375.798 472.824 385.883 461.335 383.903C449.865 381.928 431.617 371.198 429.598 368.068C427.579 364.938 430.646 359.242 434.509 359.987C438.087 360.677 455.838 368.229 455.838 368.229C455.838 368.229 444.418 347.976 441.63 342.546C436.972 333.479 448.431 324.093 455.454 334.014Z",
    fill: "#6A5EE3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M455.658 368.091C455.658 368.091 461.639 371.064 460.91 369.817C460.18 368.57 453.376 364.189 453.376 364.189L455.658 368.091Z",
    fill: "black",
    fillOpacity: 0.302803
  })), /*#__PURE__*/React.createElement("g", {
    id: "RLeg_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M356.139 476.493C356.139 476.493 356.278 487.453 347.252 491.551C338.231 495.648 331.804 495.402 332.622 498.57C333.44 501.737 356.92 501.609 359.112 499.132C360.981 497.024 365.045 477.399 366.164 478.9L356.139 476.493Z",
    fill: "url(#paint12_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M363.281 488.761C362.273 486.813 362.209 492.295 358.234 491.087C355.007 490.106 353.904 484.495 351.865 485.724C349.827 486.953 331.88 496.482 331.778 496.539C329.568 497.73 330.186 501.338 333.918 501.968C338.065 502.667 359.551 502.196 360.704 501.09C361.857 499.984 364.089 490.324 363.281 488.761Z",
    fill: "#222D4E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path 14_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M349.211 489.001C349.534 489.001 349.844 489.375 350.079 489.765C350.358 490.228 350.106 490.8 349.607 491.006L340.52 494.75C340.179 494.89 339.78 494.84 339.543 494.558C339.366 494.346 339.217 494.097 339.301 493.923C339.476 493.557 348.534 489.001 349.211 489.001Z",
    fill: "white",
    fillOpacity: 0.540975
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M449.852 390.655C449.852 390.655 461.504 415.278 445.129 423.733C429.293 431.91 381.884 422.239 381.884 422.239C381.884 422.239 382.731 429.064 381.884 435.15C379.672 451.047 369.149 477.532 366.923 480.86C363.844 485.462 354.465 481.991 354.289 478.159C354.112 474.327 361.359 425.387 362.461 416.054C363.557 406.721 367.018 405.365 377.127 402.814C379.45 402.228 406.914 395.398 409.43 395.597C431.048 397.308 449.852 390.655 449.852 390.655Z",
    fill: "#2C3757"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    opacity: 0.461565,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M437.078 421.192C421.4 422.95 379.892 419.326 378.225 420.973C376.633 422.545 376.899 449.892 373.328 465.721L373.871 464.226C377.229 454.895 380.716 443.546 381.884 435.15C382.731 429.063 381.884 422.239 381.884 422.239L383.796 422.609C392.807 424.303 431.193 430.929 445.129 423.733C452.68 419.834 455.761 413.357 454.373 404.302C451.982 414.537 446.217 420.167 437.078 421.192Z",
    fill: "white",
    fillOpacity: 0.192499
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M420.798 439.204C420.798 425.888 431.593 415.093 444.909 415.093L513.507 415.093V489.512C513.507 490.477 512.725 491.26 511.76 491.26H420.798L420.798 439.204Z",
    fill: "#86E5F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 80"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_32",
    d: "M525.002 449.738H532.049C538.86 449.738 544.382 455.26 544.382 462.071V462.071H537.335C530.524 462.071 525.002 456.55 525.002 449.738V449.738Z",
    fill: "#2CE780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_33",
    d: "M533.812 442.69H539.097C542.502 442.69 545.263 445.451 545.263 448.857V448.857H539.978C536.572 448.857 533.812 446.096 533.812 442.69V442.69Z",
    fill: "#2C9048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_34",
    d: "M561.119 448.857H554.953C549.115 448.857 544.382 453.59 544.382 459.428V459.428H550.548C556.386 459.428 561.119 454.695 561.119 448.857V448.857Z",
    fill: "#2C9048"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M553.551 437.592L548.535 439.628C544.618 441.218 542.726 445.676 544.303 449.598V449.598L549.319 447.561C553.235 445.971 555.127 441.513 553.551 437.592V437.592Z",
    fill: "#2CE780"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M540.651 436.524C543.407 438.271 545.155 441.594 545.258 445.242L545.263 445.585V471.762H543.849V445.585C543.849 442.516 542.461 439.686 540.213 438.134L539.978 437.978L540.651 436.524Z",
    fill: "#2C9048"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.863 462.952H555.838C556.865 462.952 557.697 463.767 557.697 464.773V464.825C557.697 465.937 558.237 466.982 559.152 467.641L559.721 468.051C560.636 468.71 561.176 469.755 561.176 470.867V498.077C561.176 500.008 559.578 501.573 557.608 501.573H532.094C530.123 501.573 528.525 500.008 528.525 498.077V470.867C528.525 469.755 529.066 468.71 529.98 468.051L530.55 467.641C531.403 467.026 531.931 466.074 531.997 465.046L532.005 464.773C532.005 463.767 532.837 462.952 533.863 462.952Z",
    fill: "#DA4E4F"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 528,
    y: 462,
    width: 34,
    height: 40
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M533.863 462.952H555.838C556.865 462.952 557.697 463.767 557.697 464.773V464.825C557.697 465.937 558.237 466.982 559.152 467.641L559.721 468.051C560.636 468.71 561.176 469.755 561.176 470.867V498.077C561.176 500.008 559.578 501.573 557.608 501.573H532.094C530.123 501.573 528.525 500.008 528.525 498.077V470.867C528.525 469.755 529.066 468.71 529.98 468.051L530.55 467.641C531.403 467.026 531.931 466.074 531.997 465.046L532.005 464.773C532.005 463.767 532.837 462.952 533.863 462.952Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M527.633 461.205H536.554C532.617 476.222 542.205 488.676 536.554 504.019H527.633V461.205Z",
    fill: "#E95B5C"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_39",
    x: 528.525,
    y: 486.544,
    width: 32.6507,
    height: 3.49504,
    fill: "#FFDFE2",
    fillOpacity: 0.257949
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_40",
    x: 528.525,
    y: 476.932,
    width: 32.6507,
    height: 3.49504,
    fill: "#FFDFE2",
    fillOpacity: 0.257949
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M535.899 432.926L540.054 434.123C543.536 435.126 545.549 438.758 544.555 442.242V442.242L540.4 441.044C536.918 440.041 534.905 436.41 535.899 432.926V432.926Z",
    fill: "#2CE780"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f",
    x: 0.563437,
    y: 136.563,
    width: 214.362,
    height: 215.873,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.71828,
    result: "effect1_foregroundBlur"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 151.672,
    y: 296,
    width: 223.848,
    height: 160.486,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 5,
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0862745 0 0 0 0 0.113725 0 0 0 0 0.192157 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d",
    x: 156.677,
    y: 174,
    width: 218.281,
    height: 139.723,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0189934 0 0 0 0 0.0189934 0 0 0 0 0.0189934 0 0 0 0.11 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 108.297,
    y1: 474.323,
    x2: 109.454,
    y2: 500.285,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 48.1839,
    y1: 476.621,
    x2: 50.2903,
    y2: 499.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 64.3142,
    y1: 187.794,
    x2: 73.8016,
    y2: 231.539,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 66.6994,
    y1: 179.45,
    x2: 72.7913,
    y2: 209.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 159.942,
    y1: 213.8,
    x2: 160.255,
    y2: 244.962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 48.3163,
    y1: 286.84,
    x2: 49.2509,
    y2: 310.713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 444.258,
    y1: 299.089,
    x2: 434.496,
    y2: 342.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFAFAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F07777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 443.5,
    y1: 290.813,
    x2: 437.643,
    y2: 319.461,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 402.089,
    y1: 469.477,
    x2: 400.685,
    y2: 495.712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 374.717,
    y1: 503.263,
    x2: 332.365,
    y2: 421.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28324F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#222735"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 370.207,
    y1: 324.616,
    x2: 368.311,
    y2: 349.813,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 439.765,
    y1: 350.643,
    x2: 439.209,
    y2: 366.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear",
    x1: 371.98,
    y1: 470.534,
    x2: 370.607,
    y2: 499.778,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDC6C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB2B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDark);
export default __webpack_public_path__ + "static/media/error-dark.6eb96baf644d32f9cf536c768fc4b4f4.svg";
export { ForwardRef as ReactComponent };